module.exports = __webpack_public_path__ + "static/media/1.2e845f72.jpg";